import { all } from 'redux-saga/effects';
import reports from './reports';

export const reportsSaga = function* root() {
  yield all([reports()]);
};
